var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"d-flex align-items-center justify-content-center border-bottom hp-border-color-dark-60 py-16",attrs:{"cols":"12"}},[_c('logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }